import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'

NProgress.configure({
  showSpinner: false // 是否显示加载ico;是否在显示加载图标
})

interface MetaType {
  hide?: boolean
  backgroundColor?: string
  // 是否为自定义菜单下拉
  custom?: true
  cacheList?: string[]
  name?: string //名称菜单名称
  keepAlive?: boolean
  noAuth?: boolean //是否需要路由验证
  target?: '_blank'
  title?: string
  isLink?: boolean
}
export interface MyRoute1 extends Omit<RouteRecordRaw, 'meta'> {
  meta?: MetaType // 根据需求设置额外的meta字段
}
export interface MyRoute extends Omit<MyRoute1, 'children'> {
  children?: MyRoute1[] // 根据需求设置额外的children字段
}

const menus: MyRoute[] = [
  // 全题型练习
  {
    path: 'question',
    name: '全题型练习',
    meta: { name: '全题型练习', custom: true, backgroundColor: '#FAFAFA' },
    component: () => import('@/views/q-type-list/index.vue')
  },
  {
    path: 'data',
    name: '学习数据',
    meta: {
      name: '学习数据',
      backgroundColor: `linear-gradient(
        138deg,
        #f3f3ff 0%,
        #fbf6fe 17%,
        #eceeff 69%,
        #f2f3f5 100%
      )`
    },
    component: () => import('@/views/learning/index.vue')
  },
  {
    path: 'tools',
    name: '学习工具',
    redirect: '/tools/favorites',
    meta: {
      name: '学习工具'
    }
  },
  {
    path: '/vip',
    meta: { name: '集训线下班', target: '_blank', title: 'PTE VIP开通' },
    name: 'vip'
  },

  // 高频题目列表
  {
    path: 'high',
    name: 'high',
    meta: {
      hide: true,
      backgroundColor: '#fafafa',
      name: '高频榜单'
    },
    component: () => import('@/views/high/index.vue')
  },
  // 任意题型列表
  {
    path: 'question-list/:type/:id',
    name: 'QuestionList',
    meta: {
      name: '全题型练习',
      hide: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/question-list/index.vue')
  },
  // 练习页
  {
    path: '/:slug(exp.*?)/:typeCode/:wpId/:questionsId?', //  /阅读|口语.../题型/id/questionsId
    name: 'Exercises',
    meta: {
      name: '全题型练习',
      hide: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/exercises/index.vue')
  },
  // 高频微课(列表页)
  {
    path: '/micro-course',
    name: 'MicroCourse',
    meta: {
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true,
      name: 'PTE微课'
    },
    component: () => import('@/views/micro-course/index.vue')
  },
  // 高频微课详情
  {
    path: '/micro-info/:type/:id',
    name: 'MicroInfo',
    meta: {
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true
    },
    component: () => import('@/views/micro-info/index.vue')
  },
  {
    path: '/',
    name: '课程资料',
    meta: {
      name: '课程资料'
    },
    component: () => import('@/views/information/index.vue')
  },
  {
    path: '/video-info/:courseType/:id',
    name: 'VideoInfo',
    meta: {
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true
    },
    props: (route) => ({
      microCourseId: route.query.microCourseId
    }),
    component: () => import('@/views/video-info/index.vue')
  },
  {
    path: 'center',
    name: 'center',
    meta: {
      name: '个人中心',
      backgroundColor: '#FAFAFA',
      hide: true
    },
    component: () => import('@/views/myCenter/index.vue')
  },
  {
    path: '/test', //测试页
    name: 'test',
    meta: {
      hide: true,
      noAuth: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/test')
  },

  {
    path: '/mock', //测试页
    name: 'mock',
    redirect: '/mock/exam',
    meta: {
      hide: true,
      backgroundColor: '#FAFAFA',
      title: '羊驼PTE模考'
    },
    component: () => import('@/views/mock/index.vue'),
    children: [
      {
        path: 'record',
        name: 'record',
        meta: {
          hide: true,
          backgroundColor: '#FAFAFA',
          title: '模考记录'
        },
        component: () => import('@/views/mock/subpage/record/index.vue')
      },
      {
        path: 'exam',
        name: 'exam',
        meta: {
          hide: true,
          backgroundColor: '#FAFAFA'
        },
        component: () => import('@/views/mock/subpage/exam/index.vue')
      },
      {
        path: 'Mock-Analysis/:id/:questionId',
        name: 'MockAnalysis',
        meta: {
          hide: true,
          backgroundColor: '#F7F7F7',
          title: '模考解析'
        },
        component: () => import('@/views/mock/MockAnalysis/index.vue')
      },
      {
        path: 'report/:id',
        name: 'MockReport',
        meta: {
          hide: true,
          backgroundColor: '#FAFAFA',
          title: '模考报告',
          noAuth: true
        },
        component: () => import('@/views/mock-report/index.vue')
      }
    ]
  },
  {
    path: '/IntensiveListening',
    name: 'IntensiveListening',
    redirect: '/IntensiveListening/ListeningList',
    meta: {
      hide: true,
      backgroundColor: '#FAFAFA',
      title: '精听跟读'
    },
    component: () => import('@/views/IntensiveListening/index.vue'),
    children: [
      {
        path: '/IntensiveListening/ListeningList',
        name: 'ListeningList',
        component: () =>
          import('@/views/IntensiveListening/module/ListeningList/ListeningList.vue'),
        children: [
          {
            path: '/IntensiveListening/ListeningList/list',
            name: 'ListeningListList-List',
            component: () => import('@/views/IntensiveListening/module/ListeningList/list.vue')
          },
          {
            path: '/IntensiveListening/ListeningList/details',
            name: 'ListeningListList-details',
            component: () => import('@/views/IntensiveListening/module/ListeningList/info.vue')
          }
        ]
      },
      {
        path: '/IntensiveListening/ListeningListDetails',
        name: 'ListeningListDetails',
        meta: {
          name: ''
        },
        component: () => import('@/views/IntensiveListening/module/ListeningListDetails.vue')
      }
    ]
  }
]

const router = createRouter({
  scrollBehavior() {},
  history: createWebHistory('/biyingpte/'),
  routes: [
    {
      path: '/',
      component: () => import('@/components/topLayout/index.vue'),
      children: [
        {
          path: '/',
          component: () => import('@/components/layout/index.vue'),
          meta: {
            name: '首页',
            title: '首页',
            backgroundColor: `linear-gradient(
              138deg,
              #f3f3ff 0%,
              #fbf6fe 17%,
              #eceeff 69%,
              #f2f3f5 100%
            )`
          },
          children: [...(menus as unknown as RouteRecordRaw[])]
        },
        {
          path: '/vip',
          name: 'vip',
          meta: {
            name: 'vip',
            noAuth: true,
            backgroundColor: '#FAFAFA',
            title: 'PTE VIP开通'
          },
          component: () => import('@/views/vip/index.vue')
        },
        {
          path: 'material',
          name: 'material',
          meta: {
            name: 'material',
            noAuth: true,
            backgroundColor: '#FAFAFA',
            title: '课程资料'
          },
          component: () => import('@/views/information/index.vue')
        },
        {
          path: '/material/purchase/:id',
          name: 'purchase',
          meta: {
            name: 'material',
            noAuth: true,
            backgroundColor: '#FAFAFA',
            keepAlive: true,
            title: '课程详情'
          },
          component: () => import('@/views/paid-course-info/index.vue')
        }
      ]
    },
    {
      path: '/home',
      redirect: '/',
      meta: {
        hide: true
      }
    },
    // 课程详情页
    {
      path: '/course-info',
      name: 'CourseInfo',

      meta: {
        hide: true,
        backgroundColor: '#FAFAFA',
        noAuth: true
      },
      component: () => import('@/views/course-info/index.vue')
    },
    {
      path: '/RecordTest',
      meta: {
        noAuth: true
      },
      component: () => import('@/views/test/RecordTest.vue')
    },
    {
      path: '/PTE-MockExam',
      name: 'PTE-MockExam',
      meta: {
        backgroundColor: `#F7F7F7`,
        title: '羊驼PTE-完整模考-'
      },
      component: () => import('@/views/mock/MockExam/index.vue')
    },

    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/404.vue')
    }
  ]
})

router.beforeEach(async (to) => {
  const toMeta = to.meta as MetaType
  NProgress.start() // 进度条开始
  if (toMeta.title) {
    document.title = toMeta.title
  } else {
    document.title = '羊驼PTE官网 - PTE学习_PTE考试培训_PTE真题_PTE机经'
  }
})
router.afterEach(() => {
  NProgress.done() // 进度条消失
})

// 在部署期间用户一直停留在当前项目页面（长时间无操作 半个小时+），部署完成后点击页面上的路由，报错！ 刷新后恢复正常。
router.onError((error) => {
  const fetchResourcesErrors = [
    'Failed to fetch dynamically imported module',
    'Importing a module script failed'
  ]
  if (fetchResourcesErrors.some((item) => error?.message && error.message?.includes(item))) {
    window.location.reload()
  }
})

export { router, menus }
